import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { InteractiveText } from "@silvertours/front-shared";
import { StyledAnchor, StyledMaskedLink } from "./LinkButton.styles";
var LinkButton = function(param) {
    var className = param.className, content = param.content, variant = param.variant, rules = param.rules;
    if (!content) {
        return null;
    }
    var href = content.href, label = content.label, target = content.target, rel = content.rel;
    var ref = rules || {}, tmp = ref.horizontalSpacing, ref1 = tmp === void 0 ? {} : tmp, _isCentered = ref1.isCentered, isCentered = _isCentered === void 0 ? false : _isCentered, _size = ref.size, size = _size === void 0 ? "large" : _size;
    var isSmallButton = size === "small";
    var isSecondaryButton = variant === "secondary";
    return content.masked ? /*#__PURE__*/ _jsx(StyledMaskedLink, {
        body: /*#__PURE__*/ _jsx(InteractiveText, {
            inline: true,
            textColor: "current",
            size: isSmallButton ? "small" : "normal",
            children: label
        }),
        className: className,
        href: href,
        target: target,
        rel: rel,
        isCentered: isCentered,
        isSmallButton: isSmallButton,
        isSecondaryButton: isSecondaryButton
    }) : /*#__PURE__*/ _jsx(StyledAnchor, {
        className: className,
        href: href,
        target: target,
        rel: rel,
        isCentered: isCentered,
        isSmallButton: isSmallButton,
        isSecondaryButton: isSecondaryButton,
        children: /*#__PURE__*/ _jsx(InteractiveText, {
            inline: true,
            textColor: "current",
            size: isSmallButton ? "small" : "normal",
            children: label
        })
    });
};
var defaultProps = {
    variant: "primary"
};
LinkButton.defaultProps = defaultProps;
export { LinkButton };
